import { Button, Col, Form, Input, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { ContainerData, emptyRequestDataProperties as emptyData } from "../../../../api/data-types";
import { GdriveParams } from "../../util/data-types/data-types-search-page";

import "./search-types.css";
interface GDriveSearchProps {
  theme: string
  sendDataComponent: (
    container: ContainerData,
    GDriveLink: string,
    offset: number,
    previousOffset: number,
    limit: number
  ) => Promise<void>;
  limit: number;
  selectedContainer: ContainerData;
  GdrivefromUrl: GdriveParams;
}

interface FormData {
  link: string;
}

export const GdriveSearch = ({
  theme,
  sendDataComponent,
  limit,
  selectedContainer,
  GdrivefromUrl
}: GDriveSearchProps) => {
  const [form] = Form.useForm<FormData>();

  const [loading, setLoading] = useState<boolean>(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    await sendDataComponent(
      selectedContainer,
      values.link as string,
      Number(emptyData.EMPTY_OFFSET),
      Number(emptyData.EMPTY_OFFSET),
      limit
    );
    setLoading(false);
  };

  useEffect(() => {
    form.setFieldValue('link',GdrivefromUrl.GdriveLink);
  },[GdrivefromUrl])

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <Form 
      onFinish={onFinish}
      form={form}
    >
      <div>
        <Col span={24}>
          <Row
            gutter={10}
            align="top"
            style={{ marginTop: "10px", height: "50px", marginBottom:"18px"}}
          >
            <Col span={4} style={{ textAlign: "right"}}>
              <span className="textOnPageColumn" style={{ fontSize: "18px",   }}>GDrive Link</span>
            </Col>
            <Col span={16} style={{ minWidth: "180px", paddingLeft: "0px", paddingRight: "0px" }}>
              <Form.Item
                name="link"
                style={{ marginLeft: "0px", height: "50px", paddingLeft: "8px"}}
                rules={[
                  { required: true, message: "Please input GDrive link!" },
                ]}
              >
                <Input placeholder="" style={{color:textColor}} />
              </Form.Item>
            </Col> 
            <Col span={4}>
              <Space>
                <Form.Item>
                  <Button
                    className="searchButton"
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    
                  >
                    Search
                  </Button>
                </Form.Item>
              </Space>
            </Col>
          </Row>
        </Col>
      </div>
    </Form>
  );
};
